import {RefObject, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {IQueryValue} from "@pg-mono/request";
import {RequestState} from "@pg-mono/request-state";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {fetchOfferDetailProperties, PropertyListTabTypes} from "../../offer/detail/actions/fetch_offer_detail_properties";
import {OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE} from "../../offer/detail/constants/offer_detail_properties";
import {changeFilterTabHit} from "../../tracking/algolytics_hits/change_filter_tab_hit";
import {useUserPreferencesFilters} from "../../user/hooks/use_user_preferences_filters";
import {ViewType} from "../../view_type/ViewType";

export type IPropertyListObj = ReturnType<typeof usePropertyList>;

export const usePropertyList = (
    offerId: number | null,
    tab?: PropertyListTabTypes,
    paginationClickScrollToRef?: RefObject<HTMLElement | null>,
    pageSize = OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE,
    defaultFilters?: Record<string, IQueryValue>
) => {
    const {rooms_1, rooms_0, area_0, area_1, ..._rest} = useUserPreferencesFilters();

    const [currentSort, setCurrentSort] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTab, setCurrentTab] = useState<PropertyListTabTypes>(tab ? tab : PropertyListTabTypes.FILTER);
    const [currentFilters, setCurrentFilters] = useState<Record<string, IQueryValue>>(() => {
        return defaultFilters || {rooms_0, rooms_1, area_0, area_1};
    });
    const {isMobile} = useUserDevice();

    const properties = useSelector((state: IRPStore) => state.offerDetail.properties[currentTab]?.properties);
    const requestState = useSelector((state: IRPStore) => state.offerDetail.properties[currentTab]?.requestState);
    const filterRequestState = useSelector((state: IRPStore) => state.offerDetail.properties.filter.requestState);
    const propertiesCount = useSelector((state: IRPStore) => state.offerDetail.properties[currentTab]?.count);

    const dispatch = useDispatch();

    const onFiltersChange = (value: Record<string, IQueryValue> = {}) => {
        if (offerId) {
            const filters = {...currentFilters, ...value};
            fetchOfferDetailProperties(
                offerId,
                currentTab,
                pageSize,
                {
                    sort: currentSort,
                    page: currentPage
                },
                filters
            )(dispatch);
            setCurrentFilters(filters);
        }
    };

    const onSortChange = (value: string | null, filters: Record<string, IQueryValue> = {}) => {
        if (offerId) {
            setCurrentSort(value);
            fetchOfferDetailProperties(
                offerId,
                currentTab,
                pageSize,
                {
                    sort: value,
                    page: currentPage
                },
                {...currentFilters, ...filters}
            )(dispatch);
        }
    };

    const onPageChange = async (page: number, filters: Record<string, IQueryValue> = {}, includeNavbarOffset = false): Promise<unknown[] | void> => {
        if (offerId) {
            setCurrentPage(page);
            const properties = await fetchOfferDetailProperties(offerId, currentTab, pageSize, {page: page, sort: currentSort}, filters)(dispatch);
            if (paginationClickScrollToRef?.current) {
                const offset = isMobile ? 80 : 120;
                const navbarOffset = includeNavbarOffset ? offset : 0;
                const y = window.scrollY + paginationClickScrollToRef.current.getBoundingClientRect().top - navbarOffset;
                window.scrollTo({top: y, behavior: "smooth"});
            }
            return properties;
        }
    };

    const onTabChange = (tab: PropertyListTabTypes, viewType: ViewType) => {
        if (offerId) {
            setCurrentPage(1);
            setCurrentTab(tab);
            changeFilterTabHit(tab, viewType);
            fetchOfferDetailProperties(
                offerId,
                tab,
                pageSize,
                {
                    sort: currentSort,
                    page: currentPage
                },
                currentFilters
            )(dispatch);
        }
    };

    const pageCount = propertiesCount ? Math.ceil(propertiesCount / (pageSize ? pageSize : OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE)) : 1;

    return useMemo(
        () => ({
            sort: {currentSort, setCurrentSort},
            page: {currentPage, setCurrentPage},
            tab: {currentTab, setCurrentTab},
            filters: {currentFilters, setCurrentFilters},
            onSortChange,
            onPageChange,
            onTabChange,
            onFiltersChange,
            filterRequestState,
            pageCount,
            properties,
            requestState,
            pageIsLoading: requestState === RequestState.Waiting
        }),
        [
            offerId,
            tab,
            paginationClickScrollToRef,
            pageSize,
            pageCount,
            requestState,
            properties,
            filterRequestState,
            currentSort,
            currentPage,
            currentFilters,
            currentTab
        ]
    );
};
import {RefObject, useMemo, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {IQueryValue} from "@pg-mono/request";
import {RequestState} from "@pg-mono/request-state";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {fetchOfferDetailProperties, PropertyListTabTypes} from "../../offer/detail/actions/fetch_offer_detail_properties";
import {OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE} from "../../offer/detail/constants/offer_detail_properties";
import {changeFilterTabHit} from "../../tracking/algolytics_hits/change_filter_tab_hit";
import {useUserPreferencesFilters} from "../../user/hooks/use_user_preferences_filters";
import {ViewType} from "../../view_type/ViewType";

export type IPropertyListObj = ReturnType<typeof usePropertyList>;

export const usePropertyList = (
    offerId: number | null,
    tab?: PropertyListTabTypes,
    paginationClickScrollToRef?: RefObject<HTMLElement | null>,
    pageSize = OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE,
    defaultFilters?: Record<string, IQueryValue>
) => {
    const {rooms_1, rooms_0, area_0, area_1, ..._rest} = useUserPreferencesFilters();

    const [currentSort, setCurrentSort] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTab, setCurrentTab] = useState<PropertyListTabTypes>(tab ? tab : PropertyListTabTypes.FILTER);
    const [currentFilters, setCurrentFilters] = useState<Record<string, IQueryValue>>(() => {
        return defaultFilters || {rooms_0, rooms_1, area_0, area_1};
    });
    const {isMobile} = useUserDevice();

    const properties = useSelector((state: IRPStore) => state.offerDetail.properties[currentTab]?.properties);
    const requestState = useSelector((state: IRPStore) => state.offerDetail.properties[currentTab]?.requestState);
    const filterRequestState = useSelector((state: IRPStore) => state.offerDetail.properties.filter.requestState);
    const propertiesCount = useSelector((state: IRPStore) => state.offerDetail.properties[currentTab]?.count);

    const dispatch = useDispatch();

    const onFiltersChange = (value: Record<string, IQueryValue> = {}) => {
        if (offerId) {
            const filters = {...currentFilters, ...value};
            fetchOfferDetailProperties(
                offerId,
                currentTab,
                pageSize,
                {
                    sort: currentSort,
                    page: currentPage
                },
                filters
            )(dispatch);
            setCurrentFilters(filters);
        }
    };

    const onSortChange = (value: string | null, filters: Record<string, IQueryValue> = {}) => {
        if (offerId) {
            setCurrentSort(value);
            fetchOfferDetailProperties(
                offerId,
                currentTab,
                pageSize,
                {
                    sort: value,
                    page: currentPage
                },
                {...currentFilters, ...filters}
            )(dispatch);
        }
    };

    const onPageChange = async (page: number, filters: Record<string, IQueryValue> = {}, includeNavbarOffset = false): Promise<unknown[] | void> => {
        if (offerId) {
            setCurrentPage(page);
            const properties = await fetchOfferDetailProperties(offerId, currentTab, pageSize, {page: page, sort: currentSort}, filters)(dispatch);
            if (paginationClickScrollToRef?.current) {
                const offset = isMobile ? 80 : 120;
                const navbarOffset = includeNavbarOffset ? offset : 0;
                const y = window.scrollY + paginationClickScrollToRef.current.getBoundingClientRect().top - navbarOffset;
                window.scrollTo({top: y, behavior: "smooth"});
            }
            return properties;
        }
    };

    const onTabChange = (tab: PropertyListTabTypes, viewType: ViewType) => {
        if (offerId) {
            setCurrentPage(1);
            setCurrentTab(tab);
            changeFilterTabHit(tab, viewType);
            fetchOfferDetailProperties(
                offerId,
                tab,
                pageSize,
                {
                    sort: currentSort,
                    page: currentPage
                },
                currentFilters
            )(dispatch);
        }
    };

    const pageCount = propertiesCount ? Math.ceil(propertiesCount / (pageSize ? pageSize : OFFER_DETAIL_PROPERTY_LIST_DEFAULT_PAGE_SIZE)) : 1;

    return useMemo(
        () => ({
            sort: {currentSort, setCurrentSort},
            page: {currentPage, setCurrentPage},
            tab: {currentTab, setCurrentTab},
            filters: {currentFilters, setCurrentFilters},
            onSortChange,
            onPageChange,
            onTabChange,
            onFiltersChange,
            filterRequestState,
            pageCount,
            properties,
            requestState,
            pageIsLoading: requestState === RequestState.Waiting
        }),
        [
            offerId,
            tab,
            paginationClickScrollToRef,
            pageSize,
            pageCount,
            requestState,
            properties,
            filterRequestState,
            currentSort,
            currentPage,
            currentFilters,
            currentTab
        ]
    );
};
